import React, {Component} from "react";
import {
    FormGroup,
    ControlLabel,
    FormControl,
    HelpBlock
}                         from "react-bootstrap";
import Select             from "react-select";
import                         "react-select/dist/react-select.css";

import {
  IS_VALID
}                         from "utils";

import Loader             from "../../Loader";

class Create extends Component {
    constructor (props) {
        super(props);

        this.state = {
            isLoadingRelation: false
        };

        this.getRelation = this.getRelation.bind(this);
    }

    getRelation () {
        let {
            CustomBlockMessage,
            actions,

            getRelation
        } = this.props;

        let {
            formType,
            selectedData
        } = CustomBlockMessage;

        if (
            IS_VALID(selectedData) &&
            formType.toUpperCase() === "UPDATE"
        ) {
            this.setState({ isLoadingRelation: true });

            getRelation()
            .then((cardTypes) => {
                actions.setValue({
                    cardType: cardTypes.map((item) => ({
                        label: item.get("name"),
                        value: item.id
                    }))
                });
                this.setState({ isLoadingRelation: false });
            })
            .catch((err) => {
                console.log("getRelation error");
                console.log(err);

                this.setState({ isLoadingRelation: false });
            });
        }
    }

    render () {
        let {
            isLoadingRelation
        } = this.state;

        let {
            CustomBlockMessage,
            actions,

            loadOptions,
            checkCardType
        } = this.props;

        let {
            isLoadingAction,

            name,
            cardType,
            message,

            isCheckingCardType,
            isCardTypeExist,
            errorMessage
        } = CustomBlockMessage;

        let requiredSpan = <span style={{ color: "red" }}>*</span>;

        let loadingComponent = (
            <div style={{ textAlign: "center" }}>
                <i className="fa fa-spinner fa-spin"></i>
            </div>
        );

        return (
            <form>
                <Loader loading={isLoadingAction}/>
                <FormGroup>
                    <ControlLabel>Name {requiredSpan}</ControlLabel>
                    <FormControl
                        type="text"
                        placeholder="Enter Name..."
                        value={name}
                        onChange={(e) => {
                            actions.setValue({
                                name: e.target.value
                            });
                        }}
                    />
                </FormGroup>
                <FormGroup
                    validationState={isCardTypeExist ? "error" : null}
                >
                    <ControlLabel>Card Type {requiredSpan}</ControlLabel>
                    {isLoadingRelation ? (
                        loadingComponent
                    ) : (
                        <Select.Async
                            multi={true}
                            placeholder="Select or Search..."
                            disabled={isCheckingCardType}
                            loadOptions={(input, cb) => loadOptions(input, cb)}
                            value={cardType}
                            onChange={(value) => {
                                actions.setValue({
                                    cardType: value
                                });

                                checkCardType(value);
                            }}
                        />
                    )}
                    {isCardTypeExist ? (
                        <HelpBlock>{errorMessage}</HelpBlock>
                    ) : (
                        ""
                    )}
                </FormGroup>
                <FormGroup>
                    <ControlLabel>Message {requiredSpan}</ControlLabel>
                    <FormControl
                        componentClass="textarea" 
                        placeholder="Enter Message..."
                        value={message}
                        onChange={(e) => {
                            actions.setValue({
                                message: e.target.value
                            });
                        }}
                    />
                </FormGroup>
            </form>
        );
    }

    componentDidMount () {
        this.getRelation();
    }
}

import {connect} from "react-redux";

function mapStateToProps(state) {
	let {
        CustomBlockMessage
	} = state;

	return {
        CustomBlockMessage
	};
}

export default connect(mapStateToProps)(Create);


// WEBPACK FOOTER //
// ./components/CustomBlockMessage/FormContainer/Create.js